const antdTheme = {
  token: {
    colorPrimary: "#2f6bff",
    colorText: "#1a2233",
    colorTextSecondary: "#667085",
    colorBorder: "#dde3ee",
    colorBgContainer: "#ffffff",
    borderRadius: 10,
    fontFamily: "Poppins, sans-serif",
  },
};

export default antdTheme;
